/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Message, MessageContent, MessageHeader } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { getOrderItemToRemove } from './_helpers/orderItemFilter'

const RemoveOrderItemsReminderMessage = ({orderItems}) => {
    const [t] = useTranslation()

    const orderItemsToRemove =  getOrderItemToRemove(orderItems)

    if (orderItemsToRemove.length === 0) {
        return null
    }

    return (
      <Message
        icon
        color="orange"
      >
          <MessageContent>
              <MessageHeader>
                {t('order.remove_order_items_reminder.message', {count: orderItemsToRemove.length})}</MessageHeader>
              <ul css={css`
                  margin-bottom: 0;
              `}>
                  {orderItemsToRemove.map((orderItem) => (
                    <li key={orderItem.id}>{orderItem.name}</li>
                  ))}
              </ul>
          </MessageContent>
      </Message>
    )
}

export { RemoveOrderItemsReminderMessage }
